export function inBatches(
  array: $TSFixMe[],
  batchSize: number,
  callback: (batch: $TSFixMe[]) => void
): void {
  if (batchSize <= 0) {
    throw new Error('Batch size must be greater than 0');
  }

  for (let i = 0; i < array.length; i += batchSize) {
    callback(array.slice(i, i + batchSize));
  }
}
